import { IProductFeatureState, ProductFeatureTypes, REQUEST_PRODUCT_FEATURE, RECEIVE_PRODUCT_FEATURE } from "./types";

const initialState: IProductFeatureState = { productFeatureData: undefined, isLoading: false };

export function productFeatureReducer(state = initialState, action: ProductFeatureTypes): IProductFeatureState {
    if (state === undefined) {
        return initialState;
    }

    switch (action.type) {
        case RECEIVE_PRODUCT_FEATURE:
            return {
                isLoading: false,
                productFeatureData: action.productFeatureData,
            };
        case REQUEST_PRODUCT_FEATURE:
            return {
                isLoading: true,
                productFeatureData: state.productFeatureData,
            };
        default:
            return state;
    }
}
